import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as mainStateRiskCategories from '../reducers';
import * as fromsubStateRiskCategories from '../reducers/get-risk-factor.reducer';

export const selectRiskCategoriesRequest = createSelector(
  mainStateRiskCategories.selectGetRiskCategoryState,
  fromsubStateRiskCategories.selectRiskCategories
);

export const selectRiskCategoriesLoaded = createSelector(
  mainStateRiskCategories.selectGetRiskCategoryState,
  fromsubStateRiskCategories.selectRiskCategoriesLoaded
);

export const selectRiskCategoriesFailure = createSelector(
  mainStateRiskCategories.selectGetRiskCategoryState,
  fromsubStateRiskCategories.selectRiskCategoriesError
);
